import { BrowserRouter, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { routes, previewRoutes } from './list'
import NoAccess from '@pages/NoAccess'
import NoMobile from '@pages/NoMobile'
import Auth from '@pages/Auth'
import SignUpVk from '@pages/Auth/SignUpVk'
import RestorePassword from '@pages/Auth/RestorePassword'
import { AuthApp } from '@pages/Auth/app'
import { selectProfile, selectIsAuth } from '@store/profile.reducer'
import { useScreenWidth } from '@hooks/useScreenWidth'
// import Layout from '@common/Layout'
import Register from '@pages/Auth/Register'
import Technical from '@common/Technical'
import Layout from '@common/Layout/Layout'
import { useFcmMessaging } from '@/hooks/useFcmMessaging'
import WrapperNewsViewing from '@pages/NewsViewing'
import Survey from '@pages/MySurveys/Components/FollowingLink'
import { lazy, Suspense } from 'react'
import Preloader from '@UI/Preloader'
import RequiredSurveyModal from '@/components/modals/RequiredSurvey'
import RequiredNumberConfirmationModal from '@/components/modals/RequiredNumberConfirmation'

import CoursesCatalog from '@pages/CoursesCatalog'
import NoAuthLayout from '../components/common/Layout/NoAuthLayout'
import useDefaultAuthRedirect from './components/useDefaultAuthRedirect'
import { RequiredActivateTelegramBot } from '@/components/modals/ActivateTelegramBot'
import RequiredEmailConfirmation from '@modals/RequiredEmailConfirmation/RequiredEmailConfirmation'
const PaymentWithoutRegistration = lazy(()=>import('../components/pages/CoursesCatalog/PaymentWithoutRegistration'));

const Routing = () => {
  useFcmMessaging()
  const profile = useSelector(selectProfile)
  const isAuth = useSelector(selectIsAuth)
  const isMobile = useScreenWidth(992)
  const href = window.location.href
  const isPreviewNoAuth = Boolean(~href.indexOf('preview-no-auth'))

  return (
    <BrowserRouter>
      <Technical />
      {isAuth && !isPreviewNoAuth && (
        <Layout>
          <Suspense
            fallback={
              <main className="page-content">
                <Preloader fullScreen="center" />
              </main>
            }
          >
            {routes.map((route, i) => {
              let access =
                !(route.forRole && !route.forRole.includes(profile?.role)) ||
                profile?.role === 'admin' ||
                profile?.role === 'junior-admin'
              const Component = access
                ? route.noMobile && isMobile
                  ? NoMobile
                  : route.components
                : NoAccess

              return (
                <Route
                  exact={route.exact}
                  path={route.path}
                  key={i}
                  render={() => <Component {...route.props} />}
                />
              )
            })}
          </Suspense>
          <RequiredSurveyModal />
          <RequiredEmailConfirmation />
          <RequiredNumberConfirmationModal />
          <RequiredActivateTelegramBot />
        </Layout>
      )}
      {isPreviewNoAuth && (
        <NoAuthLayout>
          <Suspense
            fallback={
              <main className="page-content">
                <Preloader fullScreen="center" />
              </main>
            }
          >
            {previewRoutes.map((route, i) => {
              let access =
                !(route.forRole && !route.forRole.includes(profile?.role)) ||
                profile?.role === 'admin' ||
                profile?.role === 'junior-admin'
              const Component = access
                ? route.noMobile && isMobile
                  ? NoMobile
                  : route.components
                : NoAccess

              return (
                <Route
                  exact={route.exact}
                  path={route.path}
                  key={i}
                  render={() => <Component {...route.props} />}
                />
              )
            })}
          </Suspense>
          <RequiredSurveyModal />
          <RequiredNumberConfirmationModal />
        </NoAuthLayout>
      )}
      <Route exact={true} path="/auth" render={() => <Auth />} />
      <Route exact={true} path="/register" render={() => <Register />} />
      <Route exact={true} path="/signup-vk" render={() => <SignUpVk />} />
      <Route
        exact={true}
        path="/restore-password"
        render={() => <RestorePassword />}
      />
      <Route exact={true} path="/auth/app" render={() => <AuthApp />} />
      {!isAuth && (
        <>
          <Route
            exact={true}
            path="/news/:id"
            label="Новость"
            render={() => <WrapperNewsViewing />}
          />
          <Route
            exact={true}
            path="/my-survey-link/:id"
            render={() => <Survey />}
          />
          <Route path="/courses/all" render={() => <CoursesCatalog />} />
          <Suspense
            fallback={
              <main className="page-content">
                <Preloader fullScreen="center" />
              </main>
            }
          >
            <Route path="/payment-without-registration" render={() => <PaymentWithoutRegistration />} />
          </Suspense>
        </>
      )}
    </BrowserRouter>
  )
}

export default Routing
